import React from 'react';
import ReferenceAutocompleteInput from './ReferenceAutocompleteInput';

const NameAutocompleteInput = (props) => {
	return <ReferenceAutocompleteInput searchField="name" {...props} />;
};

export default NameAutocompleteInput;
